/* template */
<template><div class="spinner"></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m7c48ff6a"}'>
@keyframes spinner {
	to {
		transform: rotate(360deg);
	}
}

.spinner {
	height: 70rpx;
	width 70rpx
	border-radius 50%
  border-top: 10rpx solid #FC9590;
	border-right: 10rpx solid transparent;
	animation: spinner 600ms linear infinite;
}
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'

createComponent({
  name: 'Spinner',
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "spinner7c48ff6a",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
